// @generated by protobuf-ts 2.0.4
// @generated from protobuf file "ui.proto" (package "proto", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { RaidSimResult } from "./api";
import { RaidSimRequest } from "./api";
import { Raid } from "./api";
import { Blessings } from "./paladin";
import { Glyphs } from "./common";
import { Cooldowns } from "./common";
import { Race } from "./common";
import { Consumes } from "./common";
import { IndividualBuffs } from "./common";
import { EquipmentSpec } from "./common";
import { Encounter } from "./common";
import { Player } from "./api";
import { PartyBuffs } from "./common";
import { RaidTarget } from "./common";
import { Debuffs } from "./common";
import { RaidBuffs } from "./common";
import { Faction } from "./common";
/**
 * @generated from protobuf message proto.SimSettings
 */
export interface SimSettings {
    /**
     * @generated from protobuf field: int32 iterations = 1;
     */
    iterations: number;
    /**
     * @generated from protobuf field: int32 phase = 2;
     */
    phase: number;
    /**
     * @generated from protobuf field: int64 fixed_rng_seed = 3;
     */
    fixedRngSeed: bigint;
    /**
     * @generated from protobuf field: bool show_damage_metrics = 8;
     */
    showDamageMetrics: boolean;
    /**
     * @generated from protobuf field: bool show_threat_metrics = 4;
     */
    showThreatMetrics: boolean;
    /**
     * @generated from protobuf field: bool show_healing_metrics = 7;
     */
    showHealingMetrics: boolean;
    /**
     * @generated from protobuf field: bool show_experimental = 5;
     */
    showExperimental: boolean;
    /**
     * @generated from protobuf field: proto.Faction faction = 6;
     */
    faction: Faction;
}
/**
 * Contains all information that is imported/exported from an individual sim.
 *
 * @generated from protobuf message proto.IndividualSimSettings
 */
export interface IndividualSimSettings {
    /**
     * @generated from protobuf field: proto.SimSettings settings = 5;
     */
    settings?: SimSettings;
    /**
     * @generated from protobuf field: proto.RaidBuffs raid_buffs = 1;
     */
    raidBuffs?: RaidBuffs;
    /**
     * @generated from protobuf field: proto.Debuffs debuffs = 8;
     */
    debuffs?: Debuffs;
    /**
     * @generated from protobuf field: repeated proto.RaidTarget tanks = 7;
     */
    tanks: RaidTarget[];
    /**
     * @generated from protobuf field: proto.PartyBuffs party_buffs = 2;
     */
    partyBuffs?: PartyBuffs;
    /**
     * @generated from protobuf field: proto.Player player = 3;
     */
    player?: Player;
    /**
     * @generated from protobuf field: proto.Encounter encounter = 4;
     */
    encounter?: Encounter;
    /**
     * @generated from protobuf field: repeated double ep_weights = 6;
     */
    epWeights: number[];
    /**
     * @generated from protobuf field: int32 target_dummies = 9;
     */
    targetDummies: number;
}
/**
 * Local storage data for gear settings.
 *
 * @generated from protobuf message proto.SavedGearSet
 */
export interface SavedGearSet {
    /**
     * @generated from protobuf field: proto.EquipmentSpec gear = 1;
     */
    gear?: EquipmentSpec;
    /**
     * @generated from protobuf field: repeated double bonus_stats = 2;
     */
    bonusStats: number[];
}
/**
 * Local storage data for other settings.
 *
 * @generated from protobuf message proto.SavedSettings
 */
export interface SavedSettings {
    /**
     * @generated from protobuf field: proto.RaidBuffs raid_buffs = 1;
     */
    raidBuffs?: RaidBuffs;
    /**
     * @generated from protobuf field: proto.PartyBuffs party_buffs = 2;
     */
    partyBuffs?: PartyBuffs;
    /**
     * @generated from protobuf field: proto.Debuffs debuffs = 7;
     */
    debuffs?: Debuffs;
    /**
     * @generated from protobuf field: proto.IndividualBuffs player_buffs = 3;
     */
    playerBuffs?: IndividualBuffs;
    /**
     * @generated from protobuf field: proto.Consumes consumes = 4;
     */
    consumes?: Consumes;
    /**
     * @generated from protobuf field: proto.Race race = 5;
     */
    race: Race;
    /**
     * @generated from protobuf field: proto.Cooldowns cooldowns = 6;
     */
    cooldowns?: Cooldowns;
    /**
     * @generated from protobuf field: string rotation_json = 8;
     */
    rotationJson: string;
}
/**
 * @generated from protobuf message proto.SavedTalents
 */
export interface SavedTalents {
    /**
     * @generated from protobuf field: string talents_string = 1;
     */
    talentsString: string;
    /**
     * @generated from protobuf field: proto.Glyphs glyphs = 2;
     */
    glyphs?: Glyphs;
}
/**
 * A buff bot placed in a raid.
 *
 * @generated from protobuf message proto.BuffBot
 */
export interface BuffBot {
    /**
     * Uniquely identifies which buffbot this is.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: int32 raid_index = 2;
     */
    raidIndex: number;
    /**
     * The assigned player to innervate. Only used for druid buffbots.
     *
     * @generated from protobuf field: proto.RaidTarget innervate_assignment = 3;
     */
    innervateAssignment?: RaidTarget;
    /**
     * The assigned player to PI. Only used for disc priest buffbots.
     *
     * @generated from protobuf field: proto.RaidTarget power_infusion_assignment = 4;
     */
    powerInfusionAssignment?: RaidTarget;
    /**
     * @generated from protobuf field: proto.RaidTarget tricks_of_the_trade_assignment = 5;
     */
    tricksOfTheTradeAssignment?: RaidTarget;
    /**
     * @generated from protobuf field: proto.RaidTarget unholy_frenzy_assignment = 6;
     */
    unholyFrenzyAssignment?: RaidTarget;
}
/**
 * @generated from protobuf message proto.BlessingsAssignment
 */
export interface BlessingsAssignment {
    /**
     * Index corresponds to Spec that the blessing should be applied to.
     *
     * @generated from protobuf field: repeated proto.Blessings blessings = 1;
     */
    blessings: Blessings[];
}
/**
 * @generated from protobuf message proto.BlessingsAssignments
 */
export interface BlessingsAssignments {
    /**
     * Assignments for each paladin.
     *
     * @generated from protobuf field: repeated proto.BlessingsAssignment paladins = 1;
     */
    paladins: BlessingsAssignment[];
}
/**
 * Local storage data for a saved encounter.
 *
 * @generated from protobuf message proto.SavedEncounter
 */
export interface SavedEncounter {
    /**
     * @generated from protobuf field: proto.Encounter encounter = 1;
     */
    encounter?: Encounter;
}
/**
 * Local storage data for raid sim settings.
 *
 * @generated from protobuf message proto.SavedRaid
 */
export interface SavedRaid {
    /**
     * @generated from protobuf field: proto.Raid raid = 1;
     */
    raid?: Raid;
    /**
     * @generated from protobuf field: repeated proto.BuffBot buff_bots = 2;
     */
    buffBots: BuffBot[];
    /**
     * @generated from protobuf field: proto.BlessingsAssignments blessings = 3;
     */
    blessings?: BlessingsAssignments;
    /**
     * @generated from protobuf field: proto.Faction faction = 4;
     */
    faction: Faction;
    /**
     * @generated from protobuf field: int32 phase = 5;
     */
    phase: number;
}
/**
 * Contains all information that is imported/exported from a raid sim.
 *
 * @generated from protobuf message proto.RaidSimSettings
 */
export interface RaidSimSettings {
    /**
     * @generated from protobuf field: proto.SimSettings settings = 5;
     */
    settings?: SimSettings;
    /**
     * @generated from protobuf field: proto.Raid raid = 1;
     */
    raid?: Raid;
    /**
     * @generated from protobuf field: repeated proto.BuffBot buff_bots = 2;
     */
    buffBots: BuffBot[];
    /**
     * @generated from protobuf field: proto.BlessingsAssignments blessings = 3;
     */
    blessings?: BlessingsAssignments;
    /**
     * @generated from protobuf field: proto.Encounter encounter = 4;
     */
    encounter?: Encounter;
}
/**
 * All the data related to running the sim once.
 *
 * @generated from protobuf message proto.SimRun
 */
export interface SimRun {
    /**
     * @generated from protobuf field: proto.RaidSimRequest request = 1;
     */
    request?: RaidSimRequest;
    /**
     * @generated from protobuf field: proto.RaidSimResult result = 2;
     */
    result?: RaidSimResult;
}
/**
 * Contains a sim run and also other context data.
 *
 * @generated from protobuf message proto.SimRunData
 */
export interface SimRunData {
    /**
     * @generated from protobuf field: proto.SimRun run = 1;
     */
    run?: SimRun;
    /**
     * The run stored as a reference, for comparison to the current run.
     *
     * @generated from protobuf field: proto.SimRun reference_run = 2;
     */
    referenceRun?: SimRun;
}
/**
 * Sent by the sim to the detailed results page.
 *
 * @generated from protobuf message proto.DetailedResultsUpdate
 */
export interface DetailedResultsUpdate {
    /**
     * @generated from protobuf oneof: data
     */
    data: {
        oneofKind: "runData";
        /**
         * Show results from a run.
         *
         * @generated from protobuf field: proto.SimRunData run_data = 1;
         */
        runData: SimRunData;
    } | {
        oneofKind: "settings";
        /**
         * Update sim settings.
         *
         * @generated from protobuf field: proto.SimSettings settings = 2;
         */
        settings: SimSettings;
    } | {
        oneofKind: undefined;
    };
}
// @generated message type with reflection information, may provide speed optimized methods
class SimSettings$Type extends MessageType<SimSettings> {
    constructor() {
        super("proto.SimSettings", [
            { no: 1, name: "iterations", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "phase", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "fixed_rng_seed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "show_damage_metrics", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "show_threat_metrics", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "show_healing_metrics", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "show_experimental", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "faction", kind: "enum", T: () => ["proto.Faction", Faction] }
        ]);
    }
    create(value?: PartialMessage<SimSettings>): SimSettings {
        const message = { iterations: 0, phase: 0, fixedRngSeed: 0n, showDamageMetrics: false, showThreatMetrics: false, showHealingMetrics: false, showExperimental: false, faction: 0 };
        Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimSettings): SimSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 iterations */ 1:
                    message.iterations = reader.int32();
                    break;
                case /* int32 phase */ 2:
                    message.phase = reader.int32();
                    break;
                case /* int64 fixed_rng_seed */ 3:
                    message.fixedRngSeed = reader.int64().toBigInt();
                    break;
                case /* bool show_damage_metrics */ 8:
                    message.showDamageMetrics = reader.bool();
                    break;
                case /* bool show_threat_metrics */ 4:
                    message.showThreatMetrics = reader.bool();
                    break;
                case /* bool show_healing_metrics */ 7:
                    message.showHealingMetrics = reader.bool();
                    break;
                case /* bool show_experimental */ 5:
                    message.showExperimental = reader.bool();
                    break;
                case /* proto.Faction faction */ 6:
                    message.faction = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 iterations = 1; */
        if (message.iterations !== 0)
            writer.tag(1, WireType.Varint).int32(message.iterations);
        /* int32 phase = 2; */
        if (message.phase !== 0)
            writer.tag(2, WireType.Varint).int32(message.phase);
        /* int64 fixed_rng_seed = 3; */
        if (message.fixedRngSeed !== 0n)
            writer.tag(3, WireType.Varint).int64(message.fixedRngSeed);
        /* bool show_damage_metrics = 8; */
        if (message.showDamageMetrics !== false)
            writer.tag(8, WireType.Varint).bool(message.showDamageMetrics);
        /* bool show_threat_metrics = 4; */
        if (message.showThreatMetrics !== false)
            writer.tag(4, WireType.Varint).bool(message.showThreatMetrics);
        /* bool show_healing_metrics = 7; */
        if (message.showHealingMetrics !== false)
            writer.tag(7, WireType.Varint).bool(message.showHealingMetrics);
        /* bool show_experimental = 5; */
        if (message.showExperimental !== false)
            writer.tag(5, WireType.Varint).bool(message.showExperimental);
        /* proto.Faction faction = 6; */
        if (message.faction !== 0)
            writer.tag(6, WireType.Varint).int32(message.faction);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SimSettings
 */
export const SimSettings = new SimSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IndividualSimSettings$Type extends MessageType<IndividualSimSettings> {
    constructor() {
        super("proto.IndividualSimSettings", [
            { no: 5, name: "settings", kind: "message", T: () => SimSettings },
            { no: 1, name: "raid_buffs", kind: "message", T: () => RaidBuffs },
            { no: 8, name: "debuffs", kind: "message", T: () => Debuffs },
            { no: 7, name: "tanks", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => RaidTarget },
            { no: 2, name: "party_buffs", kind: "message", T: () => PartyBuffs },
            { no: 3, name: "player", kind: "message", T: () => Player },
            { no: 4, name: "encounter", kind: "message", T: () => Encounter },
            { no: 6, name: "ep_weights", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "target_dummies", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<IndividualSimSettings>): IndividualSimSettings {
        const message = { tanks: [], epWeights: [], targetDummies: 0 };
        Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<IndividualSimSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IndividualSimSettings): IndividualSimSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.SimSettings settings */ 5:
                    message.settings = SimSettings.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                case /* proto.RaidBuffs raid_buffs */ 1:
                    message.raidBuffs = RaidBuffs.internalBinaryRead(reader, reader.uint32(), options, message.raidBuffs);
                    break;
                case /* proto.Debuffs debuffs */ 8:
                    message.debuffs = Debuffs.internalBinaryRead(reader, reader.uint32(), options, message.debuffs);
                    break;
                case /* repeated proto.RaidTarget tanks */ 7:
                    message.tanks.push(RaidTarget.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* proto.PartyBuffs party_buffs */ 2:
                    message.partyBuffs = PartyBuffs.internalBinaryRead(reader, reader.uint32(), options, message.partyBuffs);
                    break;
                case /* proto.Player player */ 3:
                    message.player = Player.internalBinaryRead(reader, reader.uint32(), options, message.player);
                    break;
                case /* proto.Encounter encounter */ 4:
                    message.encounter = Encounter.internalBinaryRead(reader, reader.uint32(), options, message.encounter);
                    break;
                case /* repeated double ep_weights */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.epWeights.push(reader.double());
                    else
                        message.epWeights.push(reader.double());
                    break;
                case /* int32 target_dummies */ 9:
                    message.targetDummies = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IndividualSimSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.SimSettings settings = 5; */
        if (message.settings)
            SimSettings.internalBinaryWrite(message.settings, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* proto.RaidBuffs raid_buffs = 1; */
        if (message.raidBuffs)
            RaidBuffs.internalBinaryWrite(message.raidBuffs, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.Debuffs debuffs = 8; */
        if (message.debuffs)
            Debuffs.internalBinaryWrite(message.debuffs, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.RaidTarget tanks = 7; */
        for (let i = 0; i < message.tanks.length; i++)
            RaidTarget.internalBinaryWrite(message.tanks[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* proto.PartyBuffs party_buffs = 2; */
        if (message.partyBuffs)
            PartyBuffs.internalBinaryWrite(message.partyBuffs, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.Player player = 3; */
        if (message.player)
            Player.internalBinaryWrite(message.player, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.Encounter encounter = 4; */
        if (message.encounter)
            Encounter.internalBinaryWrite(message.encounter, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated double ep_weights = 6; */
        if (message.epWeights.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.epWeights.length; i++)
                writer.double(message.epWeights[i]);
            writer.join();
        }
        /* int32 target_dummies = 9; */
        if (message.targetDummies !== 0)
            writer.tag(9, WireType.Varint).int32(message.targetDummies);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.IndividualSimSettings
 */
export const IndividualSimSettings = new IndividualSimSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SavedGearSet$Type extends MessageType<SavedGearSet> {
    constructor() {
        super("proto.SavedGearSet", [
            { no: 1, name: "gear", kind: "message", T: () => EquipmentSpec },
            { no: 2, name: "bonus_stats", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<SavedGearSet>): SavedGearSet {
        const message = { bonusStats: [] };
        Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SavedGearSet>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SavedGearSet): SavedGearSet {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.EquipmentSpec gear */ 1:
                    message.gear = EquipmentSpec.internalBinaryRead(reader, reader.uint32(), options, message.gear);
                    break;
                case /* repeated double bonus_stats */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.bonusStats.push(reader.double());
                    else
                        message.bonusStats.push(reader.double());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SavedGearSet, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.EquipmentSpec gear = 1; */
        if (message.gear)
            EquipmentSpec.internalBinaryWrite(message.gear, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated double bonus_stats = 2; */
        if (message.bonusStats.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.bonusStats.length; i++)
                writer.double(message.bonusStats[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SavedGearSet
 */
export const SavedGearSet = new SavedGearSet$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SavedSettings$Type extends MessageType<SavedSettings> {
    constructor() {
        super("proto.SavedSettings", [
            { no: 1, name: "raid_buffs", kind: "message", T: () => RaidBuffs },
            { no: 2, name: "party_buffs", kind: "message", T: () => PartyBuffs },
            { no: 7, name: "debuffs", kind: "message", T: () => Debuffs },
            { no: 3, name: "player_buffs", kind: "message", T: () => IndividualBuffs },
            { no: 4, name: "consumes", kind: "message", T: () => Consumes },
            { no: 5, name: "race", kind: "enum", T: () => ["proto.Race", Race] },
            { no: 6, name: "cooldowns", kind: "message", T: () => Cooldowns },
            { no: 8, name: "rotation_json", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SavedSettings>): SavedSettings {
        const message = { race: 0, rotationJson: "" };
        Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SavedSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SavedSettings): SavedSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.RaidBuffs raid_buffs */ 1:
                    message.raidBuffs = RaidBuffs.internalBinaryRead(reader, reader.uint32(), options, message.raidBuffs);
                    break;
                case /* proto.PartyBuffs party_buffs */ 2:
                    message.partyBuffs = PartyBuffs.internalBinaryRead(reader, reader.uint32(), options, message.partyBuffs);
                    break;
                case /* proto.Debuffs debuffs */ 7:
                    message.debuffs = Debuffs.internalBinaryRead(reader, reader.uint32(), options, message.debuffs);
                    break;
                case /* proto.IndividualBuffs player_buffs */ 3:
                    message.playerBuffs = IndividualBuffs.internalBinaryRead(reader, reader.uint32(), options, message.playerBuffs);
                    break;
                case /* proto.Consumes consumes */ 4:
                    message.consumes = Consumes.internalBinaryRead(reader, reader.uint32(), options, message.consumes);
                    break;
                case /* proto.Race race */ 5:
                    message.race = reader.int32();
                    break;
                case /* proto.Cooldowns cooldowns */ 6:
                    message.cooldowns = Cooldowns.internalBinaryRead(reader, reader.uint32(), options, message.cooldowns);
                    break;
                case /* string rotation_json */ 8:
                    message.rotationJson = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SavedSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.RaidBuffs raid_buffs = 1; */
        if (message.raidBuffs)
            RaidBuffs.internalBinaryWrite(message.raidBuffs, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.PartyBuffs party_buffs = 2; */
        if (message.partyBuffs)
            PartyBuffs.internalBinaryWrite(message.partyBuffs, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.Debuffs debuffs = 7; */
        if (message.debuffs)
            Debuffs.internalBinaryWrite(message.debuffs, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* proto.IndividualBuffs player_buffs = 3; */
        if (message.playerBuffs)
            IndividualBuffs.internalBinaryWrite(message.playerBuffs, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.Consumes consumes = 4; */
        if (message.consumes)
            Consumes.internalBinaryWrite(message.consumes, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* proto.Race race = 5; */
        if (message.race !== 0)
            writer.tag(5, WireType.Varint).int32(message.race);
        /* proto.Cooldowns cooldowns = 6; */
        if (message.cooldowns)
            Cooldowns.internalBinaryWrite(message.cooldowns, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string rotation_json = 8; */
        if (message.rotationJson !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.rotationJson);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SavedSettings
 */
export const SavedSettings = new SavedSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SavedTalents$Type extends MessageType<SavedTalents> {
    constructor() {
        super("proto.SavedTalents", [
            { no: 1, name: "talents_string", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "glyphs", kind: "message", T: () => Glyphs }
        ]);
    }
    create(value?: PartialMessage<SavedTalents>): SavedTalents {
        const message = { talentsString: "" };
        Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SavedTalents>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SavedTalents): SavedTalents {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string talents_string */ 1:
                    message.talentsString = reader.string();
                    break;
                case /* proto.Glyphs glyphs */ 2:
                    message.glyphs = Glyphs.internalBinaryRead(reader, reader.uint32(), options, message.glyphs);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SavedTalents, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string talents_string = 1; */
        if (message.talentsString !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.talentsString);
        /* proto.Glyphs glyphs = 2; */
        if (message.glyphs)
            Glyphs.internalBinaryWrite(message.glyphs, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SavedTalents
 */
export const SavedTalents = new SavedTalents$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BuffBot$Type extends MessageType<BuffBot> {
    constructor() {
        super("proto.BuffBot", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "raid_index", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "innervate_assignment", kind: "message", T: () => RaidTarget },
            { no: 4, name: "power_infusion_assignment", kind: "message", T: () => RaidTarget },
            { no: 5, name: "tricks_of_the_trade_assignment", kind: "message", T: () => RaidTarget },
            { no: 6, name: "unholy_frenzy_assignment", kind: "message", T: () => RaidTarget }
        ]);
    }
    create(value?: PartialMessage<BuffBot>): BuffBot {
        const message = { id: "", raidIndex: 0 };
        Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BuffBot>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BuffBot): BuffBot {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* int32 raid_index */ 2:
                    message.raidIndex = reader.int32();
                    break;
                case /* proto.RaidTarget innervate_assignment */ 3:
                    message.innervateAssignment = RaidTarget.internalBinaryRead(reader, reader.uint32(), options, message.innervateAssignment);
                    break;
                case /* proto.RaidTarget power_infusion_assignment */ 4:
                    message.powerInfusionAssignment = RaidTarget.internalBinaryRead(reader, reader.uint32(), options, message.powerInfusionAssignment);
                    break;
                case /* proto.RaidTarget tricks_of_the_trade_assignment */ 5:
                    message.tricksOfTheTradeAssignment = RaidTarget.internalBinaryRead(reader, reader.uint32(), options, message.tricksOfTheTradeAssignment);
                    break;
                case /* proto.RaidTarget unholy_frenzy_assignment */ 6:
                    message.unholyFrenzyAssignment = RaidTarget.internalBinaryRead(reader, reader.uint32(), options, message.unholyFrenzyAssignment);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BuffBot, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* int32 raid_index = 2; */
        if (message.raidIndex !== 0)
            writer.tag(2, WireType.Varint).int32(message.raidIndex);
        /* proto.RaidTarget innervate_assignment = 3; */
        if (message.innervateAssignment)
            RaidTarget.internalBinaryWrite(message.innervateAssignment, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.RaidTarget power_infusion_assignment = 4; */
        if (message.powerInfusionAssignment)
            RaidTarget.internalBinaryWrite(message.powerInfusionAssignment, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* proto.RaidTarget tricks_of_the_trade_assignment = 5; */
        if (message.tricksOfTheTradeAssignment)
            RaidTarget.internalBinaryWrite(message.tricksOfTheTradeAssignment, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* proto.RaidTarget unholy_frenzy_assignment = 6; */
        if (message.unholyFrenzyAssignment)
            RaidTarget.internalBinaryWrite(message.unholyFrenzyAssignment, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.BuffBot
 */
export const BuffBot = new BuffBot$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlessingsAssignment$Type extends MessageType<BlessingsAssignment> {
    constructor() {
        super("proto.BlessingsAssignment", [
            { no: 1, name: "blessings", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["proto.Blessings", Blessings] }
        ]);
    }
    create(value?: PartialMessage<BlessingsAssignment>): BlessingsAssignment {
        const message = { blessings: [] };
        Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BlessingsAssignment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BlessingsAssignment): BlessingsAssignment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.Blessings blessings */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.blessings.push(reader.int32());
                    else
                        message.blessings.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BlessingsAssignment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.Blessings blessings = 1; */
        if (message.blessings.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.blessings.length; i++)
                writer.int32(message.blessings[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.BlessingsAssignment
 */
export const BlessingsAssignment = new BlessingsAssignment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BlessingsAssignments$Type extends MessageType<BlessingsAssignments> {
    constructor() {
        super("proto.BlessingsAssignments", [
            { no: 1, name: "paladins", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BlessingsAssignment }
        ]);
    }
    create(value?: PartialMessage<BlessingsAssignments>): BlessingsAssignments {
        const message = { paladins: [] };
        Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<BlessingsAssignments>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BlessingsAssignments): BlessingsAssignments {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated proto.BlessingsAssignment paladins */ 1:
                    message.paladins.push(BlessingsAssignment.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BlessingsAssignments, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated proto.BlessingsAssignment paladins = 1; */
        for (let i = 0; i < message.paladins.length; i++)
            BlessingsAssignment.internalBinaryWrite(message.paladins[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.BlessingsAssignments
 */
export const BlessingsAssignments = new BlessingsAssignments$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SavedEncounter$Type extends MessageType<SavedEncounter> {
    constructor() {
        super("proto.SavedEncounter", [
            { no: 1, name: "encounter", kind: "message", T: () => Encounter }
        ]);
    }
    create(value?: PartialMessage<SavedEncounter>): SavedEncounter {
        const message = {};
        Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SavedEncounter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SavedEncounter): SavedEncounter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.Encounter encounter */ 1:
                    message.encounter = Encounter.internalBinaryRead(reader, reader.uint32(), options, message.encounter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SavedEncounter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.Encounter encounter = 1; */
        if (message.encounter)
            Encounter.internalBinaryWrite(message.encounter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SavedEncounter
 */
export const SavedEncounter = new SavedEncounter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SavedRaid$Type extends MessageType<SavedRaid> {
    constructor() {
        super("proto.SavedRaid", [
            { no: 1, name: "raid", kind: "message", T: () => Raid },
            { no: 2, name: "buff_bots", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BuffBot },
            { no: 3, name: "blessings", kind: "message", T: () => BlessingsAssignments },
            { no: 4, name: "faction", kind: "enum", T: () => ["proto.Faction", Faction] },
            { no: 5, name: "phase", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<SavedRaid>): SavedRaid {
        const message = { buffBots: [], faction: 0, phase: 0 };
        Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SavedRaid>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SavedRaid): SavedRaid {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.Raid raid */ 1:
                    message.raid = Raid.internalBinaryRead(reader, reader.uint32(), options, message.raid);
                    break;
                case /* repeated proto.BuffBot buff_bots */ 2:
                    message.buffBots.push(BuffBot.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* proto.BlessingsAssignments blessings */ 3:
                    message.blessings = BlessingsAssignments.internalBinaryRead(reader, reader.uint32(), options, message.blessings);
                    break;
                case /* proto.Faction faction */ 4:
                    message.faction = reader.int32();
                    break;
                case /* int32 phase */ 5:
                    message.phase = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SavedRaid, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.Raid raid = 1; */
        if (message.raid)
            Raid.internalBinaryWrite(message.raid, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.BuffBot buff_bots = 2; */
        for (let i = 0; i < message.buffBots.length; i++)
            BuffBot.internalBinaryWrite(message.buffBots[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.BlessingsAssignments blessings = 3; */
        if (message.blessings)
            BlessingsAssignments.internalBinaryWrite(message.blessings, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.Faction faction = 4; */
        if (message.faction !== 0)
            writer.tag(4, WireType.Varint).int32(message.faction);
        /* int32 phase = 5; */
        if (message.phase !== 0)
            writer.tag(5, WireType.Varint).int32(message.phase);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SavedRaid
 */
export const SavedRaid = new SavedRaid$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RaidSimSettings$Type extends MessageType<RaidSimSettings> {
    constructor() {
        super("proto.RaidSimSettings", [
            { no: 5, name: "settings", kind: "message", T: () => SimSettings },
            { no: 1, name: "raid", kind: "message", T: () => Raid },
            { no: 2, name: "buff_bots", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => BuffBot },
            { no: 3, name: "blessings", kind: "message", T: () => BlessingsAssignments },
            { no: 4, name: "encounter", kind: "message", T: () => Encounter }
        ]);
    }
    create(value?: PartialMessage<RaidSimSettings>): RaidSimSettings {
        const message = { buffBots: [] };
        Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<RaidSimSettings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RaidSimSettings): RaidSimSettings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.SimSettings settings */ 5:
                    message.settings = SimSettings.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                case /* proto.Raid raid */ 1:
                    message.raid = Raid.internalBinaryRead(reader, reader.uint32(), options, message.raid);
                    break;
                case /* repeated proto.BuffBot buff_bots */ 2:
                    message.buffBots.push(BuffBot.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* proto.BlessingsAssignments blessings */ 3:
                    message.blessings = BlessingsAssignments.internalBinaryRead(reader, reader.uint32(), options, message.blessings);
                    break;
                case /* proto.Encounter encounter */ 4:
                    message.encounter = Encounter.internalBinaryRead(reader, reader.uint32(), options, message.encounter);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RaidSimSettings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.SimSettings settings = 5; */
        if (message.settings)
            SimSettings.internalBinaryWrite(message.settings, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* proto.Raid raid = 1; */
        if (message.raid)
            Raid.internalBinaryWrite(message.raid, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated proto.BuffBot buff_bots = 2; */
        for (let i = 0; i < message.buffBots.length; i++)
            BuffBot.internalBinaryWrite(message.buffBots[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* proto.BlessingsAssignments blessings = 3; */
        if (message.blessings)
            BlessingsAssignments.internalBinaryWrite(message.blessings, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* proto.Encounter encounter = 4; */
        if (message.encounter)
            Encounter.internalBinaryWrite(message.encounter, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.RaidSimSettings
 */
export const RaidSimSettings = new RaidSimSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimRun$Type extends MessageType<SimRun> {
    constructor() {
        super("proto.SimRun", [
            { no: 1, name: "request", kind: "message", T: () => RaidSimRequest },
            { no: 2, name: "result", kind: "message", T: () => RaidSimResult }
        ]);
    }
    create(value?: PartialMessage<SimRun>): SimRun {
        const message = {};
        Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimRun>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimRun): SimRun {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.RaidSimRequest request */ 1:
                    message.request = RaidSimRequest.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                case /* proto.RaidSimResult result */ 2:
                    message.result = RaidSimResult.internalBinaryRead(reader, reader.uint32(), options, message.result);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimRun, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.RaidSimRequest request = 1; */
        if (message.request)
            RaidSimRequest.internalBinaryWrite(message.request, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.RaidSimResult result = 2; */
        if (message.result)
            RaidSimResult.internalBinaryWrite(message.result, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SimRun
 */
export const SimRun = new SimRun$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimRunData$Type extends MessageType<SimRunData> {
    constructor() {
        super("proto.SimRunData", [
            { no: 1, name: "run", kind: "message", T: () => SimRun },
            { no: 2, name: "reference_run", kind: "message", T: () => SimRun }
        ]);
    }
    create(value?: PartialMessage<SimRunData>): SimRunData {
        const message = {};
        Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<SimRunData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SimRunData): SimRunData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.SimRun run */ 1:
                    message.run = SimRun.internalBinaryRead(reader, reader.uint32(), options, message.run);
                    break;
                case /* proto.SimRun reference_run */ 2:
                    message.referenceRun = SimRun.internalBinaryRead(reader, reader.uint32(), options, message.referenceRun);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SimRunData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.SimRun run = 1; */
        if (message.run)
            SimRun.internalBinaryWrite(message.run, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.SimRun reference_run = 2; */
        if (message.referenceRun)
            SimRun.internalBinaryWrite(message.referenceRun, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.SimRunData
 */
export const SimRunData = new SimRunData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DetailedResultsUpdate$Type extends MessageType<DetailedResultsUpdate> {
    constructor() {
        super("proto.DetailedResultsUpdate", [
            { no: 1, name: "run_data", kind: "message", oneof: "data", T: () => SimRunData },
            { no: 2, name: "settings", kind: "message", oneof: "data", T: () => SimSettings }
        ]);
    }
    create(value?: PartialMessage<DetailedResultsUpdate>): DetailedResultsUpdate {
        const message = { data: { oneofKind: undefined } };
        Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DetailedResultsUpdate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DetailedResultsUpdate): DetailedResultsUpdate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* proto.SimRunData run_data */ 1:
                    message.data = {
                        oneofKind: "runData",
                        runData: SimRunData.internalBinaryRead(reader, reader.uint32(), options, (message.data as any).runData)
                    };
                    break;
                case /* proto.SimSettings settings */ 2:
                    message.data = {
                        oneofKind: "settings",
                        settings: SimSettings.internalBinaryRead(reader, reader.uint32(), options, (message.data as any).settings)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DetailedResultsUpdate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* proto.SimRunData run_data = 1; */
        if (message.data.oneofKind === "runData")
            SimRunData.internalBinaryWrite(message.data.runData, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* proto.SimSettings settings = 2; */
        if (message.data.oneofKind === "settings")
            SimSettings.internalBinaryWrite(message.data.settings, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message proto.DetailedResultsUpdate
 */
export const DetailedResultsUpdate = new DetailedResultsUpdate$Type();
